import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/** Field wrapper: label (+ required marker), projected control, optional hint. */
@Component({
  selector: 'bb-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bb-field.html',
  styleUrl: './bb-field.scss'
})
export class BbField {
  private readonly sanitizer = inject(DomSanitizer);

  /** Trusted, app-owned SVG markup for the label icon. */
  readonly labelIconHtml = input<string>('');
  readonly label = input<string>('');
  readonly hint = input<string>('');
  readonly required = input<boolean>(false);

  readonly trustedLabelIcon = computed<SafeHtml>(() =>
    this.sanitizer.bypassSecurityTrustHtml(this.labelIconHtml()),
  );
}
